import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { RepresentativeService } from 'src/app/Service/Representative/Representative.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-RepresentativeEdit',
  templateUrl: './RepresentativeEdit.component.html',
  styleUrls: ['./RepresentativeEdit.component.scss']
})
export class RepresentativeEditComponent implements OnInit {
  PreUserName:string=''
  InProccessing:boolean=false
  EditRecord:number

  constructor(
    private Nav_Service:NavService,
    private User_Service:UserService,
    private Representative_Service:RepresentativeService,
    private Alertify_Service:AlertifyService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.FormEditRepresentative=new FormGroup({
      id :new FormControl(),
      Password:new FormControl('',[
                                      Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')
                                    ]),
      FName:new FormControl(null,Validators.required),
      LName:new FormControl(null,Validators.required),

    })

    this.Nav_Service.CheckValidPage(1101).subscribe(
      data=>{
        this.Representative_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.PreUserName=data.username
            this.get_Form_FName().setValue(data.fname)
            this.get_Form_LName().setValue(data.lname)

            this.Read_Data_Menu()
          },error=>{
            // AuthInterceptor owns authentication; feature errors must preserve credentials.
          }
        )


      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  Data_List_Menu:Array<Nav_Interface>=[]
  Read_Data_Menu(){
    this.Nav_Service.GetUser(this.EditRecord,true).subscribe(
      data=>{
        this.Data_List_Menu=data
        this.Data_List_Menu=this.FilterNav(0)
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  FilterNav(id:Number):Array<Nav_Interface>{
    var tempList:Array<Nav_Interface>=[]
    for(let item of this.Data_List_Menu)
    {
      if(item.parent==id)
      {
          var temp:Nav_Interface=Empty_Nav_Interface()
          temp.id=item.id
          temp.icon=item.icon
          temp.link=item.link
          temp.parent=item.parent
          temp.selected=item.selected
          temp.title=item.title
          temp.child=this.FilterNav(item.id)

          tempList.push(temp)
      }

    }
    return tempList


  }

    //#region  Form Add

    FormEditRepresentative:FormGroup;

    get_Form_Password(){
      return this.FormEditRepresentative.get('Password') as FormControl;
    }

    get_Form_FName(){
      return this.FormEditRepresentative.get('FName') as FormControl;
    }

    get_Form_LName(){
      return this.FormEditRepresentative.get('LName') as FormControl;
    }

    //#endregion


    SubmitRepresentative(){

      var SelectedMenu:Array<number>=[]
      for(let lvl1 of this.Data_List_Menu)
      {
        for(let item of lvl1.child)
        {
          if(item.selected)
          {
            SelectedMenu.push(item.id)
          }
        }
      }

      var Record:User_Interface=Empty_User_Interface()
      Record.id=this.EditRecord
      Record.password = this.get_Form_Password().value
      Record.fname = this.get_Form_FName().value
      Record.lname = this.get_Form_LName().value
      Record.type = 4

      this.User_Service.EditUser(Record,SelectedMenu,[],[],[],[]).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("نام کاربری وارد شده ، در لیست وجود دارد")
          }
          else{
            //this.FormEditRepresentative.reset()
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )

    }

    Data_List_Menu_Change(id:Nav_Interface)
    {
      id.selected=!id.selected
    }

}
